import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { IPersonSearchResultItem } from '../../../models/Person';
import { AppService } from '../../../services/app.service';
import { StudentCourseEqualizationService } from '../../../services/student-course-equalization.service';
import { PersonService } from '../../../services/person.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { permissions, store } from '../shared';
import { IStudentCourseEqualizationAssigned, IStudentCourseEqualizationListItem } from '../../../models/StudentCourseEqualization';

@Component({
    selector: 'app-student-course-equalization-list',
    templateUrl: './student-course-equalization-list.component.html'
})
export class StudentCourseEqualizationListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: StudentCourseEqualizationService,
        private persons: PersonService,
        private route: ActivatedRoute
    ) { }

    items: IStudentCourseEqualizationListItem[] = [];
    assignedItems: IStudentCourseEqualizationAssigned[] = [];

    canPickStudent: boolean;
    canEdit: boolean;
    canViewAssigned: boolean;
    studentPickerOpened: boolean;
    student: IPersonSearchResultItem;

    readonly columns: ITableColumn[] = [
        { property: 'Status', label: 'studentCourseEqualization_lblStatus', cssClass: 'hidden-sm-down' },
        { property: 'Speciality', label: 'studentCourseEqualization_lblProgrammeYearCreatedRegistered', cssClass: 'hidden-sm-down hidden-lg-up' },
        { property: 'Speciality', label: 'studentCourseEqualization_lblStatusProgrammeYearCreatedRegistered', cssClass: 'hidden-md-up' },
        { property: 'Speciality', label: 'studentCourseEqualization_lblProgramme', cssClass: 'hidden-md-down' },
        { property: 'StudyYear', label: 'studentCourseEqualization_lblStudyYear', cssClass: 'hidden-md-down' },
        { property: 'Created', label: 'studentCourseEqualization_lblCreatedRegistered', cssClass: 'hidden-md-down' },
        { width: '1px' }
    ];

    readonly assignedColumns: ITableColumn[] = [
        { property: 'Name', label: 'studentCourseEqualization_lblStudent' },
        { property: 'Speciality', label: 'studentCourseEqualization_lblProgramme' },
        { property: 'StudyYear', label: 'studentCourseEqualization_lblStudyYear' },
        { property: 'Created', label: 'studentCourseEqualization_lblCreated' },
        { property: 'Status', label: 'studentCourseEqualization_lblStatus' },
        { width: '1px' }
    ];

    ngOnInit() {
        const user = this.app.currentUser;

        if (user) {
            this.canEdit = user.rights.indexOf(permissions.edit) > -1;
            this.canPickStudent = user.rights.indexOf(permissions.setStudent) > -1;

            if (this.canPickStudent) {
                this.loadAssignedItems();

                const queryUpn = this.route.snapshot.queryParams['id'];

                if (queryUpn) {
                    this.app.addLoading(this.persons.findStudents('StudentId', queryUpn)).subscribe(data => {
                        if (data.length) {
                            this.setStudent(data[0]);
                        } else {
                            this.app.showError(this.app.translate('studentNotFound'));
                        }
                    });
                } else {
                    this.student = store.getStudent();

                    if (this.student) {
                        this.loadItems();
                    } else {
                        this.toggleStudentPicker();
                    }
                }
            } else {
                this.loadItems();
            }
        }
    }

    toggleStudentPicker() {
        if (this.studentPickerOpened) {
            this.studentPickerOpened = false;
        } else {
            this.studentPickerOpened = true;
            this.items = [];
        }
    }

    setStudent(student: IPersonSearchResultItem) {
        this.studentPickerOpened = false;
        this.student = student;
        this.loadItems();

        store.setStudent(student);
    }

    delete(row: IStudentCourseEqualizationListItem) {
        this.app.confirm(this.app.translate('confirmItemDelete'), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(row.Id)).subscribe(() => {
                this.loadItems();
            });
        });
    }

    canDelete(row: IStudentCourseEqualizationListItem): boolean {
        return (this.canEdit && row.Status == 'Draft');
    }

    getStatus(row: IStudentCourseEqualizationListItem): string {
        return row.Registered ? 'Registered' : row.Status;
    }

    getDvsProtocolUrl(row: IStudentCourseEqualizationListItem): string {
        return row.Registered ? this.service.getDvsProtocolUrl(row.Id) : undefined;
    }

    private loadItems() {
        this.app.addLoading(this.service.get(this.student?.Email)).subscribe(data => {
            this.items = data;
        });
    }

    private loadAssignedItems() {
        this.app.addLoading(this.service.getAssigned()).subscribe(data => {
            this.assignedItems = data;
        });
    }
}
